<template>
    <div>
        <!-- nav -->
        <nav class="navbar d-lg-none navbar-dark bg-white flex-wrap">
            <div class="container-fluid">
                <div class="d-flex w-100 align-items-center">
                    <a class="navbar-brand" href="/">
                       <img class="sidebar-brand-logo" src="/images/logo.png" alt="Gstocky">
                    </a>
                    <button class="navbar-burger navbar-toggler bg-primary ms-auto" type="button" @click="mobileMenuOpen = !mobileMenuOpen">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                </div>
            </div>
        </nav>
        <!-- Mobile Overlay -->
        <div v-if="mobileMenuOpen" class="mobile-sidebar-overlay d-lg-none" @click="closeMobileSidebar"></div>
        <!-- Mobile Overlay End -->
        <div class="position-relative navbar-menu" :class="{'d-none': !mobileMenuOpen, 'd-lg-block': true}">
            <div class="navbar-backdrop d-lg-none position-fixed top-0 end-0 bottom-0 start-0 bg-white" style="opacity: .5"></div>
            <div
                class="position-fixed custom-sidebar d-flex flex-column overflow-hidden"
                :class="[{'rtl-sidebar': isRTL}, isShown ? 'sidebar-expanded' : 'sidebar-collapsed']"
            >
                <div class="sidebar-header flex-shrink-0 d-flex align-items-center">
                    <router-link to="/" class="sidebar-brand">
                        <img class="sidebar-brand-logo" src="/images/logo.png" alt="Gstocky">
                    </router-link>
                    <button
                        type="button"
                        class="sidebar-toggle d-none d-lg-inline-flex align-items-center justify-content-center"
                        :title="isShown ? 'Collapse sidebar' : 'Expand sidebar'"
                        :aria-label="isShown ? 'Collapse sidebar' : 'Expand sidebar'"
                        @click="toggleSidebar"
                    >
                        <SidebarIcon :name="isShown ? 'panel-left-close' : 'panel-left-open'" />
                    </button>
                    <button
                        type="button"
                        class="sidebar-mobile-close d-lg-none align-items-center justify-content-center"
                        aria-label="Close sidebar"
                        @click="closeMobileSidebar"
                    >
                        <SidebarIcon name="bi-x-lg" />
                    </button>
                </div>
                <div class="sidebar-menu-content flex-grow-1 overflow-auto">
                    <div>
                        <!-- Modules Menu -->
                        <ul class="nav flex-column sidebar-primary-nav">
                            <!-- eslint-disable-next-line vue/no-template-key vue/require-v-for-key -->
                            <template v-for="module in modulesWithoutSettings">
                                <!-- Show items based on module's expanded state -->
                                <template v-if="isModuleExpanded(module)">
                                    <!-- Show all items as top-level when expanded (no module header) -->
                                    <li v-for="item in getEnabledItems(module)" 
                                        :key="item.id" 
                                        class="nav-item nav-pills module-item" 
                                        style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                                        <router-link 
                                            :exact="item.link === '/'"
                                            style="font-weight: 600 !important;" 
                                            class="nav-link text-white d-flex align-items-center" 
                                            :to="item.link">
                                            <span class="sidebar-icon" data-bs-toggle="tooltip" data-bs-placement="right" :title="$t(item.title)">
                                                <SidebarIcon :name="item.icon" />
                                            </span>
                                            <span>{{$t(item.title)}}</span>
                                        </router-link>
                                    </li>
                                </template>
                                <!-- Nested mode: Show modules with submenus (default) -->
                                <li v-else :key="module.id" class="nav-item nav-pills module-item" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                                    <template v-if="getEnabledItems(module).length === 1">
                                        <!-- Single item - show directly with expand option -->
                                        <div class="d-flex align-items-center">
                                            <router-link 
                                                :exact="getEnabledItems(module)[0].link === '/'"
                                                style="font-weight: 600 !important;flex: 1;" 
                                                class="nav-link text-white d-flex align-items-center" 
                                                :to="getEnabledItems(module)[0].link">
                                                <span class="sidebar-icon" data-bs-toggle="tooltip" data-bs-placement="right" :title="$t(getEnabledItems(module)[0].title)">
                                                    <SidebarIcon :name="getEnabledItems(module)[0].icon" />
                                                </span>
                                                <span>{{$t(getEnabledItems(module)[0].title)}}</span>
                                            </router-link>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <!-- Multiple items - show with submenu -->
                                        <div class="nav-link text-white d-flex align-items-center justify-content-between module-link"
                                            style="font-weight: 600 !important;" 
                                             @click="toggleSubmenu(module.id)"
                                             @mouseenter="!isShown && !mobileMenuOpen ? showSubmenu(module, $event) : null"
                                             @mouseleave="!isShown && !mobileMenuOpen ? hideSubmenu() : null">
                                            <div class="d-flex align-items-center">
                                                <span class="sidebar-icon" :data-bs-toggle="isShown ? '' : 'tooltip'" data-bs-placement="right" :title="$t(module.title)">
                                                    <SidebarIcon :name="module.icon" />
                                                </span>
                                                <span>{{$t(module.title)}}</span>
                                            </div>
                                            <SidebarIcon
                                                v-if="isShown || mobileMenuOpen"
                                                class="sidebar-chevron"
                                                :name="activeModule === module.id ? 'bi-chevron-up' : 'bi-chevron-down'"
                                                :size="16"
                                            />
                                        </div>
                                        <!-- Inline submenu (when sidebar is expanded) -->
                                        <transition v-if="isShown || mobileMenuOpen" name="submenu-slide">
                                            <div v-show="activeModule === module.id" 
                                                style="font-weight: 600 !important;" 
                                                 class="submenu-container-inline">
                                                <ul class="submenu">
                                                    <li v-for="item in getEnabledItems(module)" 
                                                        :key="item.id" 
                                                        style="font-weight: 600 !important;" 
                                                        class="submenu-item">
                                                        <router-link 
                                                        style="font-weight: 600 !important;" 
                                                            :exact="item.link === '/'"
                                                            class="nav-link text-white" 
                                                            :to="item.link">
                                                            <SidebarIcon class="sidebar-submenu-icon" :name="item.icon" />
                                                            <span>{{$t(item.title)}}</span>
                                                        </router-link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </transition>
                                        <!-- Floating submenu (when sidebar is collapsed) -->
                                        <div v-if="!isShown && !mobileMenuOpen && activeModule === module.id"
                                             class="submenu-container-floating"
                                             :style="getSubmenuStyle()"
                                             @mouseenter="showSubmenu(module, $event)"
                                             @mouseleave="hideSubmenu()">
                                            <ul class="submenu">
                                                <li v-for="item in getEnabledItems(module)" 
                                                    :key="item.id" 
                                                    class="submenu-item-floating">
                                                    <router-link 
                                                        :exact="item.link === '/'"
                                                        class="nav-link text-white" 
                                                        :to="item.link">
                                                        <SidebarIcon class="sidebar-submenu-icon" :name="item.icon" />
                                                        <span>{{$t(item.title)}}</span>
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </div>
                                    </template>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
                <div class="sidebar-sticky-settings flex-shrink-0">
                        <!-- Settings always at the bottom -->
                        <ul class="nav flex-column sidebar-settings-nav">
                            <!-- eslint-disable-next-line vue/no-template-key vue/require-v-for-key -->
                            <template v-for="module in settingsModules">
                                <!-- Show items based on module's expanded state -->
                                <template v-if="isModuleExpanded(module)">
                                    <!-- Show all items as top-level when expanded (no module header) -->
                                    <li v-for="item in getEnabledItems(module)" 
                                        :key="item.id" 
                                        class="nav-item nav-pills module-item" 
                                        style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;font-weight: 600 !important;">
                                        <router-link 
                                            style="font-weight: 600 !important;"
                                            :exact="item.link === '/'"
                                            class="nav-link text-white d-flex align-items-center" 
                                            :to="item.link">
                                            <span class="sidebar-icon" data-bs-toggle="tooltip" data-bs-placement="right" :title="$t(item.title)">
                                                <SidebarIcon :name="item.icon" />
                                            </span>
                                            <span>{{$t(item.title)}}</span>
                                        </router-link>
                                    </li>
                                </template>
                                <!-- Nested mode: Show modules with submenus (default) -->
                                <li v-else :key="module.id" class="nav-item nav-pills module-item" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;font-weight: 600 !important;">
                                    <template v-if="getEnabledItems(module).length === 1"  style="font-weight: 600 !important;">
                                        <router-link 
                                            style="font-weight: 600 !important;"
                                            :exact="getEnabledItems(module)[0].link === '/'"
                                            class="nav-link text-white d-flex align-items-center" 
                                            :to="getEnabledItems(module)[0].link">
                                            <span class="sidebar-icon" data-bs-toggle="tooltip" data-bs-placement="right" :title="$t(getEnabledItems(module)[0].title)">
                                                <SidebarIcon :name="getEnabledItems(module)[0].icon" />
                                            </span>
                                            <span >{{$t(getEnabledItems(module)[0].title)}}</span>
                                        </router-link>
                                    </template>
                                    <template v-else>
                                        <div class="nav-link text-white d-flex align-items-center justify-content-between module-link" 
                                            style="font-weight: 600 !important;"
                                             @click="toggleSubmenu(module.id)"
                                             @mouseenter="!isShown && !mobileMenuOpen ? showSubmenu(module, $event) : null"
                                             @mouseleave="!isShown && !mobileMenuOpen ? hideSubmenu() : null">
                                            <div class="d-flex align-items-center">
                                                <span class="sidebar-icon" :data-bs-toggle="isShown ? '' : 'tooltip'" data-bs-placement="right" :title="$t(module.title)">
                                                    <SidebarIcon :name="module.icon" />
                                                </span>
                                                <span>{{$t(module.title)}}</span>
                                            </div>
                                            <SidebarIcon
                                                v-if="isShown || mobileMenuOpen"
                                                class="sidebar-chevron"
                                                :name="activeModule === module.id ? 'bi-chevron-up' : 'bi-chevron-down'"
                                                :size="16"
                                            />
                                        </div>
                                        <!-- Inline submenu (when sidebar is expanded) -->
                                        <transition v-if="isShown || mobileMenuOpen" name="submenu-slide">
                                            <div v-show="activeModule === module.id" 
                                                 class="submenu-container-inline">
                                                <ul class="submenu">
                                                    <li v-for="item in getEnabledItems(module)" 
                                                        :key="item.id" 
                                                        class="submenu-item">
                                                        <router-link 
                                                            :exact="item.link === '/'"
                                                            class="nav-link text-white" 
                                                            :to="item.link">
                                                            <SidebarIcon class="sidebar-submenu-icon" :name="item.icon" />
                                                            <span>{{$t(item.title)}}</span>
                                                        </router-link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </transition>
                                        <!-- Floating submenu (when sidebar is collapsed) -->
                                        <div v-if="!isShown && !mobileMenuOpen && activeModule === module.id"
                                             class="submenu-container-floating"
                                             :style="getSubmenuStyle()"
                                             @mouseenter="showSubmenu(module, $event)"
                                             @mouseleave="hideSubmenu()">
                                            <ul class="submenu">
                                                <li v-for="item in getEnabledItems(module)" 
                                                    :key="item.id" 
                                                    class="submenu-item-floating">
                                                    <router-link 
                                                        :exact="item.link === '/'"
                                                        class="nav-link text-white" 
                                                        :to="item.link">
                                                        <SidebarIcon class="sidebar-submenu-icon" :name="item.icon" />
                                                        <span>{{$t(item.title)}}</span>
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </div>
                                    </template>
                                </li>
                            </template>
                        </ul>
                </div>
                <div class="sidebar-footer flex-shrink-0">
                    <ul class="sidebar-desktop-actions nav flex-column d-none d-lg-flex">
                        <li class="nav-item nav-pills">
                            <button
                                type="button"
                                class="sidebar-footer-action nav-link text-white d-flex align-items-center"
                                :title="$t('support')"
                                :aria-label="$t('support')"
                                @click="openSupportModal"
                            >
                                <span class="sidebar-icon">
                                    <SidebarIcon name="bi-headset" />
                                </span>
                                <span v-if="isShown">{{ $t('support') }}</span>
                            </button>
                        </li>
                    </ul>

                    <!-- Mobile-only actions at the bottom of the sidebar -->
                    <div class="sidebar-actions d-lg-none p-3 w-100">
                        <div class="sidebar-mobile-action-row">
                            <SidebarIcon class="sidebar-mobile-action-icon" name="bi-headset" />
                            <a
                                href="#"
                                class="w-100 mb-2"
                                style="text-decoration:none"
                                @click.prevent="openSupportModal"
                                :title="$t('support')"
                                :aria-label="$t('support')"
                            > {{ $t('support') }}
                            </a>
                        </div>

                        <div class="sidebar-mobile-action-row">
                            <SidebarIcon class="sidebar-mobile-action-icon" name="bi-box-arrow-left" />
                            <a
                                href="#"
                                class="w-100 mb-2"
                                style="text-decoration:none"
                                @click.prevent="logout"
                                :title="$t('logout')"
                                :aria-label="$t('logout')"
                            > {{ $t('logout') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <transition name="support-modal-fade">
            <div
                v-if="supportModalOpen"
                class="support-modal-backdrop"
                role="presentation"
                @mousedown.self="closeSupportModal"
            >
                <div
                    ref="supportModal"
                    class="support-modal"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="support-modal-title"
                    aria-describedby="support-modal-description"
                    tabindex="-1"
                >
                    <button
                        type="button"
                        class="support-modal-close"
                        :aria-label="$t('close')"
                        @click="closeSupportModal"
                    >
                        <SidebarIcon name="bi-x-lg" />
                    </button>

                    <div class="support-modal-heading">
                        <span class="support-modal-heading-icon">
                            <SidebarIcon name="bi-headset" />
                        </span>
                        <div>
                            <h2 id="support-modal-title">{{ $t('support') }}</h2>
                            <p id="support-modal-description">{{ $t('choose_support_channel') }}</p>
                        </div>
                    </div>

                    <div class="support-contact-list">
                        <a
                            class="support-contact-option support-contact-option-whatsapp"
                            href="https://wa.me/212656477702"
                            target="_blank"
                            rel="noopener noreferrer"
                            @click="closeSupportModal"
                        >
                            <span class="support-contact-icon">
                                <SidebarIcon name="bi-whatsapp" />
                            </span>
                            <span class="support-contact-copy">
                                <strong>WhatsApp</strong>
                                <small dir="ltr">+212 6 56477702</small>
                            </span>
                            <SidebarIcon class="support-contact-arrow" :name="isRTL ? 'bi-arrow-left' : 'bi-arrow-right'" />
                        </a>

                        <a
                            class="support-contact-option support-contact-option-email"
                            href="mailto:support@gstocky.com"
                            @click="closeSupportModal"
                        >
                            <span class="support-contact-icon">
                                <SidebarIcon name="bi-envelope" />
                            </span>
                            <span class="support-contact-copy">
                                <strong>{{ $t('email') }}</strong>
                                <small>support@gstocky.com</small>
                            </span>
                            <SidebarIcon class="support-contact-arrow" :name="isRTL ? 'bi-arrow-left' : 'bi-arrow-right'" />
                        </a>

                        <button
                            type="button"
                            class="support-contact-option support-contact-option-chat"
                            @click="openCrispChat"
                        >
                            <span class="support-contact-icon">
                                <SidebarIcon name="bi-chat-dots" />
                            </span>
                            <span class="support-contact-copy">
                                <strong>{{ $t('chat_now') }}</strong>
                                <small>{{ $t('chat_description') }}</small>
                            </span>
                            <SidebarIcon class="support-contact-arrow" :name="isRTL ? 'bi-arrow-left' : 'bi-arrow-right'" />
                        </button>
                    </div>
                </div>
            </div>
        </transition>
        <!-- nav -->
    </div>
</template>

<script>
import helper from '../../helper'
import SidebarIcon from './SidebarIcon.vue'

export default {
    components: {
        SidebarIcon
    },
    computed: {
        role() { return this.$store.getters.ROLE },
        permissions() { return this.$store.getters.PERMISSIONS },
        user() { return this.$store.getters.USER },
        business() { return this.$store.getters.BUSINESS },
        modules(){ return this.$store.getters.MODULES },
        checkIsSubscribed(){ return helper.checkAccess('view_dashboard') != -2},
        modulesWithoutSettings() {
            return this.modules.filter(module => module.enabled && module.module_key !== 'settings');
        },
        settingsModules() {
            return this.modules.filter(module => module.enabled && module.module_key === 'settings');
        },
        isRTL() {
            return this.$i18n.locale === 'ar';
        }
    },
    data() {
        return {
            isShown: null,
            activeModule: null,
            submenuPosition: { top: 0, left: 0, right: 0 },
            hideTimeout: null,
            mobileMenuOpen: false,
            supportModalOpen: false
        }
    },
    watch: {
        isShown() {
            var tooltipTriggerList;
            if(this.isShown === true) {
                tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
                tooltipTriggerList.map(function (tooltipTriggerEl) {
                    // eslint-disable-next-line no-undef
                    return new bootstrap.Tooltip(tooltipTriggerEl).disable();
                });
            } else {
                tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
                tooltipTriggerList.map(function (tooltipTriggerEl) {
                    // eslint-disable-next-line no-undef
                    return new bootstrap.Tooltip(tooltipTriggerEl);
                });
            }
        },
        $route() {
            // Close mobile sidebar when route changes
            if (this.mobileMenuOpen) {
                this.closeMobileSidebar();
            }
        }
    },
    mounted() {
        this.menuItems = this.modules
                .filter(module => module.enabled)
                .flatMap(module => 
                    module.items
                        .filter(item => item.enabled)
                        .map(item => ({
                            id: item.id,
                            title: item.title,
                            link: item.link,
                            icon: item.icon,
                            permission: item.permission
                        }))
                );
      
        setTimeout(() => {
            if(this.isShown === false) {
                var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
                tooltipTriggerList.map(function (tooltipTriggerEl) {
                    // eslint-disable-next-line no-undef
                    return new bootstrap.Tooltip(tooltipTriggerEl);
                });
            }
        }, 1000);

        // Add keyboard shortcut for toggling sidebar (Cmd+B / Ctrl+B)
        window.addEventListener('keydown', this.handleKeyboardShortcut);
        window.addEventListener('keydown', this.handleSupportModalKeydown);

        // Removed conflicting vanilla JS event listeners - now using Vue reactive state
    },
    beforeDestroy() {
        // Clean up listeners when component is destroyed
        const navPills = document.querySelectorAll('.nav-pills');
        navPills.forEach(pill => {
            pill.removeEventListener('click', this.triggerNavbarBurger);
        });
        if (this.hideTimeout) {
            clearTimeout(this.hideTimeout);
        }
        // Remove keyboard shortcut listener
        window.removeEventListener('keydown', this.handleKeyboardShortcut);
        window.removeEventListener('keydown', this.handleSupportModalKeydown);
    },
    async created() {
        if(localStorage.getItem('navFullSize') !== null) {
            this.isShown = localStorage.getItem('navFullSize') === "true";
            this.$store.commit('SET_NAV_FULL_SIZE', this.isShown);
        } else {
            this.isShown = true;
        }
    },
    methods: {
        openSupportModal() {
            this.supportModalOpen = true;

            if (this.mobileMenuOpen) {
                this.closeMobileSidebar();
            }

            this.$nextTick(() => {
                if (this.$refs.supportModal) {
                    this.$refs.supportModal.focus();
                }
            });
        },
        closeSupportModal() {
            this.supportModalOpen = false;
        },
        handleSupportModalKeydown(event) {
            if (event.key === 'Escape' && this.supportModalOpen) {
                this.closeSupportModal();
            }
        },
        openCrispChat() {
            this.closeSupportModal();
            window.$crisp = window.$crisp || [];
            window.CRISP_WEBSITE_ID = '3aa4fac3-42c0-4b5d-9e93-19d7def099d1';

            const userEmail = this.user && this.user.email;
            if (userEmail) {
                window.$crisp.push(['set', 'user:email', [userEmail]]);
            }

            window.$crisp.push(['do', 'chat:show']);
            window.$crisp.push(['do', 'chat:open']);

            const crispScript = document.getElementById('crisp-chat-script')
                || document.querySelector('script[src="https://client.crisp.chat/l.js"]');

            if (!crispScript) {
                const script = document.createElement('script');
                script.src = 'https://client.crisp.chat/l.js';
                script.async = true;
                script.id = 'crisp-chat-script';
                document.head.appendChild(script);
            }

            if (this.mobileMenuOpen) {
                this.closeMobileSidebar();
            }
        },
        canAccess(permission) {
            // Special case for owner-only items
            if (permission === 'owner_only') {
                return this.role === 'owner';
            }
            // Regular permission check
            return this.role === 'owner' || (this.permissions && this.permissions.includes(permission));
        },
        toggleSidebar() {
            this.hideSubmenu()
            this.isShown = !this.isShown;
            this.$store.commit('SET_NAV_FULL_SIZE', this.isShown);
            localStorage.setItem('navFullSize', this.isShown);
        },
        toggleSubmenu(moduleId) {
            // Toggle submenu: close if already open, open if closed (for expanded sidebar)
            if (this.activeModule === moduleId) {
                this.activeModule = null;
            } else {
                this.activeModule = moduleId;
            }
        },
        showSubmenu(module, event) {
            // Show floating submenu on hover (for collapsed sidebar)
            if (this.hideTimeout) {
                clearTimeout(this.hideTimeout);
                this.hideTimeout = null;
            }
            this.activeModule = module.id;
            if (event) {
                const rect = event.currentTarget.getBoundingClientRect();
                const sidebarWidth = this.isShown ? 232 : 48; // 14.5rem = 232px, 3rem = 48px
                
                if (this.isRTL) {
                    // For RTL, position submenu to the left of sidebar
                    this.submenuPosition = {
                        top: rect.top,
                        right: sidebarWidth,
                        left: 'auto'
                    };
                } else {
                    // For LTR, position submenu to the right of sidebar
                    this.submenuPosition = {
                        top: rect.top,
                        left: sidebarWidth,
                        right: 'auto'
                    };
                }
            }
            
            // Hide any active tooltips when submenu is shown
            this.$nextTick(() => {
                const tooltips = document.querySelectorAll('.tooltip');
                tooltips.forEach(tooltip => {
                    tooltip.remove();
                });
            });
        },
        hideSubmenu() {
            // Hide floating submenu with delay (for collapsed sidebar)
            this.hideTimeout = setTimeout(() => {
                this.activeModule = null;
            }, 100); // Small delay to prevent flickering
        },
        getSubmenuStyle() {
            if (!this.activeModule) return {};
            const style = {
                position: 'fixed',
                top: this.submenuPosition.top + 'px'
            };
            
            if (this.isRTL) {
                style.right = this.submenuPosition.right + 'px';
                style.left = 'auto';
            } else {
                style.left = this.submenuPosition.left + 'px';
                style.right = 'auto';
            }
            
            return style;
        },
        getEnabledItems(module) {
            return module.items.filter(item => item.enabled && this.canAccess(item.permission));
        },
        isModuleExpanded(module) {
            return module.expanded === true;
        },
        logout() {
            localStorage.removeItem('access_token');
            helper.clearUserConnectedCookie();
            this.$router.push({ path: '/login' });
        },
        closeMobileSidebar() {
            this.mobileMenuOpen = false;
        },
        handleKeyboardShortcut(event) {
            // Check for Cmd+B (Mac) or Ctrl+B (Windows/Linux)
            if ((event.metaKey || event.ctrlKey) && event.key === 'b') {
                event.preventDefault(); // Prevent browser's default bookmark action
                this.toggleSidebar();
            }
        }
    }
}
</script>

<style scoped>
/* Modern full-height sidebar */
.custom-sidebar {
    --sidebar-icon-color: #64748b;
    --sidebar-icon-active-color: #0052b8;
    --sidebar-icon-hover-color: #1e293b;
    top: 14px !important;
    bottom: 14px !important;
    left: 10px !important;
    right: auto !important;
    z-index: 150;
    height: calc(100dvh - 28px);
    min-height: 0;
    box-sizing: border-box;
    background: #ffffff !important;
    border: 1px solid #ebedf2;
    border-radius: 24px;
    box-shadow: 0 1px 2px rgba(20, 24, 34, 0.04), 0 8px 28px rgba(20, 24, 34, 0.08);
    color: #545b6c;
    transition: width 0.22s ease, max-width 0.22s ease, box-shadow 0.22s ease;
}

.custom-sidebar.sidebar-expanded {
    width: calc(14.5rem - 20px) !important;
    max-width: calc(14.5rem - 20px) !important;
}

.custom-sidebar.sidebar-collapsed {
    left: 2px !important;
    width: calc(3rem - 4px) !important;
    max-width: calc(3rem - 4px) !important;
    border-radius: 18px;
}

.custom-sidebar.rtl-sidebar {
    right: 10px !important;
    left: auto !important;
}

.custom-sidebar.rtl-sidebar.sidebar-collapsed {
    right: 2px !important;
    left: auto !important;
}

.module-link,
.nav-pills a,
.sidebar-footer-action {
    cursor: pointer;
}

.sidebar-header {
    min-height: 64px;
    padding: 11px 12px 7px;
    gap: 8px;
}

.sidebar-brand {
    display: flex;
    min-width: 0;
    flex: 1;
    align-items: center;
    background: transparent !important;
    text-decoration: none !important;
}

.sidebar-brand:hover,
.sidebar-brand:focus,
.sidebar-brand.router-link-active,
.sidebar-brand.router-link-exact-active {
    background: transparent !important;
    color: #003b8a !important;
    text-decoration: none !important;
}

.sidebar-brand-logo {
    display: block;
    width: 128px;
    height: 40px;
    object-fit: cover;
    object-position: center;
    border-radius: 8px;
}

.sidebar-toggle {
    width: 32px;
    height: 32px;
    flex: 0 0 32px;
    padding: 0;
    border: 0;
    border-radius: 10px;
    background: #f5f6fa;
    color: #8f98a9;
    transition: background-color 0.18s ease, color 0.18s ease;
}

.sidebar-toggle:hover {
    background: #eef0f4;
    color: #303746;
}

.sidebar-mobile-close {
    display: inline-flex;
    width: 34px;
    height: 34px;
    flex: 0 0 34px;
    padding: 0;
    border: 0;
    border-radius: 10px;
    background: #f5f6fa;
    color: #596273;
}

.sidebar-menu-content {
    min-height: 0;
    padding: 0 8px 10px;
    overflow-x: hidden !important;
    overflow-y: auto !important;
    overscroll-behavior: contain;
    scrollbar-width: thin;
    scrollbar-color: #d8dde7 transparent;
}

.sidebar-menu-content::-webkit-scrollbar {
    width: 5px;
}

.sidebar-menu-content::-webkit-scrollbar-track {
    background: transparent;
}

.sidebar-menu-content::-webkit-scrollbar-thumb {
    background: #d8dde7;
    border-radius: 999px;
}

.custom-sidebar .nav {
    gap: 2px;
}

.sidebar-settings-nav {
    margin: 0 !important;
    background: #ffffff;
}

.sidebar-sticky-settings {
    padding: 7px 8px;
    background: #ffffff;
}

.module-item {
    overflow: visible !important;
}

.custom-sidebar .nav > .module-item > .nav-link,
.custom-sidebar .nav > .module-item > .d-flex > .nav-link,
.custom-sidebar .module-link,
.sidebar-footer-action {
    width: 100%;
    min-height: 40px;
    padding: 0 11px !important;
    border: 0;
    border-radius: 11px;
    background: transparent;
    color: #545b6c !important;
    font-size: 0.82rem !important;
    font-weight: 600 !important;
    line-height: 1.2;
    text-decoration: none;
    transition: background-color 0.18s ease, color 0.18s ease;
}

.custom-sidebar .nav > .module-item > .nav-link,
.custom-sidebar .nav > .module-item > .d-flex > .nav-link {
    flex-direction: row;
    justify-content: flex-start;
    gap: 12px;
}

.custom-sidebar .nav > .module-item > .nav-link > span:first-child,
.custom-sidebar .nav > .module-item > .d-flex > .nav-link > span:first-child,
.custom-sidebar .module-link > .d-flex > span:first-child {
    margin: 0 !important;
    color: var(--sidebar-icon-color);
}

.sidebar-icon {
    display: inline-flex;
    width: 20px;
    height: 20px;
    flex: 0 0 20px;
    align-items: center;
    justify-content: center;
    color: var(--sidebar-icon-color);
}

.sidebar-icon svg,
.sidebar-submenu-icon,
.sidebar-mobile-action-icon {
    display: block;
    width: 20px;
    height: 20px;
    flex: 0 0 20px;
}

.sidebar-icon svg {
    color: inherit !important;
}

.sidebar-submenu-icon,
.sidebar-mobile-action-icon,
.sidebar-chevron {
    color: var(--sidebar-icon-color);
}

.sidebar-icon,
.sidebar-submenu-icon,
.sidebar-mobile-action-icon,
.sidebar-chevron {
    transition: color 0.18s ease;
}

.custom-sidebar .module-link {
    position: relative;
}

.custom-sidebar .module-link > .d-flex {
    width: auto;
    min-width: 0;
    padding-inline-start: 0;
    flex-direction: row;
    justify-content: flex-start;
    gap: 12px;
}

.custom-sidebar .module-link > .sidebar-chevron {
    position: static;
    margin-inline-start: auto;
    color: var(--sidebar-icon-color);
}

.custom-sidebar .nav-link:hover,
.custom-sidebar .module-link:hover,
.sidebar-footer-action:hover {
    background: #f5f6fa !important;
    color: #303746 !important;
}

.custom-sidebar .nav-link:hover .sidebar-icon,
.custom-sidebar .nav-link:hover .sidebar-submenu-icon,
.custom-sidebar .module-link:hover .sidebar-icon,
.custom-sidebar .module-link:hover .sidebar-chevron,
.sidebar-footer-action:hover .sidebar-icon,
.sidebar-mobile-action-row:hover .sidebar-mobile-action-icon {
    color: var(--sidebar-icon-hover-color) !important;
}

.custom-sidebar .nav-link.router-link-exact-active,
.custom-sidebar .nav-link.router-link-active,
.custom-sidebar .module-item:has(.router-link-active) > .module-link {
    background: #e6ecf3 !important;
    background-image: none !important;
    color: #003b8a !important;
    box-shadow: none !important;
    text-shadow: none !important;
}

.custom-sidebar .nav-link.router-link-exact-active > span:first-child,
.custom-sidebar .nav-link.router-link-active > span:first-child,
.custom-sidebar .nav-link.router-link-exact-active .sidebar-submenu-icon,
.custom-sidebar .nav-link.router-link-active .sidebar-submenu-icon,
.custom-sidebar .module-item:has(.router-link-active) > .module-link .sidebar-icon,
.custom-sidebar .module-item:has(.router-link-active) > .module-link .sidebar-chevron {
    color: var(--sidebar-icon-active-color) !important;
}

.submenu-container-inline {
    margin: 3px 5px 5px 14px;
    padding: 3px;
    overflow: hidden;
    background: #f8fafc;
    border: 0;
    border-inline-start: 2px solid #dfe3ea;
    border-radius: 12px;
}

.submenu {
    margin: 0;
    padding: 0;
    list-style: none;
}

.submenu-item,
.submenu-item-floating {
    white-space: nowrap;
}

.submenu-item a,
.submenu-item-floating a {
    display: flex;
    align-items: center;
    min-height: 34px;
    padding: 5px 9px !important;
    gap: 12px;
    flex-direction: row;
    justify-content: flex-start;
    border-radius: 9px;
    color: #697184 !important;
    font-size: 0.78rem !important;
    font-weight: 500 !important;
}

.submenu-item a:hover,
.submenu-item-floating a:hover {
    background: #eef0f4 !important;
    color: #303746 !important;
}

.submenu-container-floating {
    min-width: 210px;
    padding: 7px;
    background: #ffffff !important;
    border: 1px solid #ebedf2;
    border-radius: 16px;
    box-shadow: 0 12px 30px rgba(20, 24, 34, 0.12);
}

.submenu-container-floating *,
.submenu-container-floating *::before,
.submenu-container-floating *::after {
    pointer-events: auto !important;
}

.submenu-item-floating {
    padding: 0;
}

.sidebar-footer {
    padding: 8px;
    background: #ffffff;
    border-top: 1px solid #ebedf2;
}

.sidebar-footer-action {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 12px;
}

.sidebar-footer-action span:first-child {
    margin: 0 !important;
    color: var(--sidebar-icon-color);
}

.support-modal-backdrop {
    position: fixed;
    inset: 0;
    z-index: 2050;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    background: rgba(15, 23, 42, 0.5);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
}

.support-modal {
    position: relative;
    width: min(100%, 460px);
    padding: 28px;
    overflow: hidden;
    background: #ffffff;
    border: 1px solid #e8ebf0;
    border-radius: 22px;
    box-shadow: 0 24px 64px rgba(15, 23, 42, 0.2);
    outline: none;
}

.support-modal-close {
    position: absolute;
    top: 16px;
    inset-inline-end: 16px;
    display: inline-flex;
    width: 34px;
    height: 34px;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    border-radius: 10px;
    background: #f4f6f8;
    color: #64748b;
}

.support-modal-close:hover,
.support-modal-close:focus-visible {
    background: #e9edf2;
    color: #1e293b;
}

.support-modal-heading {
    display: flex;
    align-items: center;
    gap: 14px;
    padding-inline-end: 42px;
    margin-bottom: 24px;
}

.support-modal-heading-icon {
    display: inline-flex;
    width: 48px;
    height: 48px;
    flex: 0 0 48px;
    align-items: center;
    justify-content: center;
    border-radius: 15px;
    background: #eaf2ff;
    color: #0052b8;
}

.support-modal-heading h2 {
    margin: 0 0 3px;
    color: #172033;
    font-size: 1.25rem;
    font-weight: 700;
}

.support-modal-heading p {
    margin: 0;
    color: #6b7280;
    font-size: 0.9rem;
}

.support-contact-list {
    display: grid;
    gap: 10px;
}

.support-contact-option {
    display: flex;
    width: 100%;
    min-width: 0;
    align-items: center;
    gap: 13px;
    padding: 14px;
    border: 1px solid #e8ebf0;
    border-radius: 14px;
    background: #ffffff;
    color: #243044;
    text-align: start;
    text-decoration: none;
    transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.support-contact-option:hover,
.support-contact-option:focus-visible {
    border-color: #cdd6e2;
    color: #172033;
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.08);
    outline: none;
    text-decoration: none;
    transform: translateY(-1px);
}

.support-contact-icon {
    display: inline-flex;
    width: 42px;
    height: 42px;
    flex: 0 0 42px;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background: #f1f5f9;
    color: #334155;
}

.support-contact-option-whatsapp .support-contact-icon {
    background: #e9f9ef;
    color: #128c4a;
}

.support-contact-option-email .support-contact-icon {
    background: #edf4ff;
    color: #1261c9;
}

.support-contact-option-chat .support-contact-icon {
    background: #f1edff;
    color: #6d45d6;
}

.support-contact-copy {
    display: flex;
    min-width: 0;
    flex: 1;
    flex-direction: column;
}

.support-contact-copy strong {
    font-size: 0.92rem;
    font-weight: 700;
}

.support-contact-copy small {
    overflow: hidden;
    color: #778195;
    font-size: 0.78rem;
    line-height: 1.35;
    text-overflow: ellipsis;
}

.support-contact-arrow {
    flex: 0 0 auto;
    color: #9aa3b2;
}

.support-modal-fade-enter-active,
.support-modal-fade-leave-active {
    transition: opacity 0.18s ease;
}

.support-modal-fade-enter-active .support-modal,
.support-modal-fade-leave-active .support-modal {
    transition: transform 0.18s ease, opacity 0.18s ease;
}

.support-modal-fade-enter,
.support-modal-fade-leave-to {
    opacity: 0;
}

.support-modal-fade-enter .support-modal,
.support-modal-fade-leave-to .support-modal {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
}

.submenu-slide-enter-active,
.submenu-slide-leave-active {
    max-height: 500px;
    transition: max-height 0.25s ease, opacity 0.2s ease;
}

.submenu-slide-enter,
.submenu-slide-leave-to {
    max-height: 0;
    opacity: 0;
}

.mobile-sidebar-overlay {
    position: fixed;
    inset: 0;
    z-index: 149;
    background: rgba(20, 24, 34, 0.42);
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
    animation: sidebar-overlay-in 0.2s ease-out;
}

@keyframes sidebar-overlay-in {
    from { opacity: 0; }
    to { opacity: 1; }
}

.sidebar-collapsed .sidebar-header {
    min-height: 54px;
    padding: 10px 4px 6px;
    justify-content: center;
}

.sidebar-collapsed .sidebar-brand {
    display: none;
}

.sidebar-collapsed .sidebar-toggle {
    width: 32px;
    height: 32px;
    flex-basis: 32px;
}

.sidebar-collapsed .sidebar-menu-content {
    padding-inline: 5px;
}

.sidebar-collapsed .nav {
    gap: 1px;
}

.sidebar-collapsed .nav > .module-item > .nav-link,
.sidebar-collapsed .nav > .module-item > .d-flex > .nav-link,
.sidebar-collapsed .module-link,
.sidebar-collapsed .sidebar-footer-action {
    min-height: 34px;
    padding: 0 !important;
    justify-content: center !important;
}

.sidebar-collapsed .nav > .module-item > .nav-link > span:first-child,
.sidebar-collapsed .nav > .module-item > .d-flex > .nav-link > span:first-child,
.sidebar-collapsed .module-link > .d-flex > span:first-child,
.sidebar-collapsed .sidebar-footer-action > span:first-child {
    display: inline-flex;
    width: 22px;
    height: 22px;
    flex: 0 0 22px;
    align-items: center;
    justify-content: center;
    margin: 0 !important;
}

.sidebar-collapsed .nav > .module-item > .nav-link > span:last-child,
.sidebar-collapsed .nav > .module-item > .d-flex > .nav-link > span:last-child,
.sidebar-collapsed .module-link > .d-flex > span:last-child,
.sidebar-collapsed .module-link > .sidebar-chevron {
    display: none;
}

.sidebar-collapsed .module-link > .d-flex {
    width: 22px;
    height: 22px;
    flex: 0 0 22px;
    padding: 0;
    align-items: center;
    justify-content: center !important;
    gap: 0;
}

.sidebar-collapsed .sidebar-settings-nav {
    margin: 0 !important;
}

.sidebar-collapsed .sidebar-sticky-settings {
    padding-inline: 5px;
}

@media (max-width: 991.98px) {
    .navbar.d-lg-none {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        z-index: 148;
        background: #ffffff !important;
        border-bottom: 1px solid #ebedf2;
        box-shadow: 0 1px 8px rgba(20, 24, 34, 0.06);
        padding-top: 0 !important;
        padding-bottom: 0 !important;
    }

    .custom-sidebar,
    .custom-sidebar.sidebar-expanded,
    .custom-sidebar.sidebar-collapsed {
        top: 0 !important;
        bottom: 0 !important;
        left: 0 !important;
        right: auto !important;
        width: min(86vw, 280px) !important;
        max-width: 280px !important;
        height: 100dvh;
        min-height: 100dvh;
        border-radius: 0 24px 24px 0;
    }

    .custom-sidebar.rtl-sidebar,
    .custom-sidebar.rtl-sidebar.sidebar-collapsed {
        right: 0 !important;
        left: auto !important;
        border-radius: 24px 0 0 24px;
    }

    .sidebar-header,
    .sidebar-collapsed .sidebar-header {
        min-height: 64px;
        padding: 11px 16px 7px;
        justify-content: space-between;
    }

    .sidebar-collapsed .sidebar-brand {
        display: flex;
    }

    .sidebar-collapsed .sidebar-menu-content {
        padding: 0 8px 10px;
    }

    .sidebar-collapsed .sidebar-sticky-settings {
        padding-inline: 8px;
    }

    .sidebar-collapsed .nav > .module-item > .nav-link,
    .sidebar-collapsed .nav > .module-item > .d-flex > .nav-link,
    .sidebar-collapsed .module-link,
    .sidebar-collapsed .sidebar-footer-action {
        min-height: 40px;
        padding: 0 11px !important;
        justify-content: flex-start !important;
    }

    .sidebar-collapsed .nav > .module-item > .nav-link > span:last-child,
    .sidebar-collapsed .nav > .module-item > .d-flex > .nav-link > span:last-child,
    .sidebar-collapsed .module-link > .d-flex > span:last-child {
        display: inline;
    }

    .sidebar-collapsed .module-link > .d-flex {
        width: auto;
        height: auto;
        flex: 0 1 auto;
        padding-inline-start: 0;
        justify-content: flex-start !important;
        gap: 12px;
    }

    .sidebar-collapsed .module-link {
        justify-content: space-between !important;
    }

    .sidebar-collapsed .module-link > .sidebar-chevron {
        display: block;
    }

    .sidebar-actions {
        background: #ffffff;
        border-top: 1px solid #ebedf2;
        padding: 8px 12px !important;
    }

    .sidebar-mobile-action-row {
        display: flex;
        min-height: 42px;
        align-items: center;
        gap: 12px;
        margin: 0;
        color: #545b6c;
    }

    .sidebar-mobile-action-icon {
        color: var(--sidebar-icon-color);
    }

    .sidebar-mobile-action-row a {
        margin: 0 !important;
        color: #545b6c;
        font-size: 0.88rem;
        font-weight: 600;
    }
}

@media (max-width: 575.98px) {
    .support-modal-backdrop {
        align-items: flex-end;
        padding: 12px;
    }

    .support-modal {
        padding: 24px 18px 18px;
        border-radius: 20px;
    }
}
</style>
